import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";
import ReceipeDetail from "../RequisitionProduction/ReceipeDetail";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [product, setProduct] = useState([]);
  const [rmpm, setRmpm] = useState([]);
  const [factory, setFactory] = useState({});
  const [list, setList] = useState([]);
  const { checkRequiredFields } = useRequiredFields();
  const [receipeNotFound, setReceipeNotFound] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const resProduct = await Http.get("/receipe-finished-good");
        setProduct(resProduct.data);

        // const resRmpm = await Http.get("/rmpm-with-stock");
        // setRmpm(resRmpm.data);
        const resRmpm = await Http.get("/product-wise-stock?type=raw_materials-packaging_materials");
        setRmpm(resRmpm.data.item);

        // const resFactory = await Http.get("/factory");
        // setFactory(resFactory.data);

        const resFactorySelect = await Http.get("/factorySelect2");
        setFactory(resFactorySelect.data);

        const resBatchNo = await Http.get(
          "/last-code-increment-by-one/productions/receipt_no/P",
        );
        setInputs((values) => ({ ...values, ["receipt_no"]: resBatchNo.data }));

        getCurrentDateInput();
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    DatatableFunc();
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSelectChange = (selectedOption) => {
    setInputs((values) => ({
      ...values,
      product_id: selectedOption ? selectedOption.value : "",
    }));

    // Clear the list when a product is selected (no recipe needed)
    setList([]);
    setReceipeNotFound("");


    // inputs.product_id = selectedOption.value;
    // Http.post("/production-load-receipe-type-wise", inputs).then((res) => {
    //   setList(res.data.purchase_order_items);
    //   setListDetail(res.data.product_purchase_detail);
    //   setListDetailId(res.data.purchase_order_items);
    // });
  };

  const handleCustomInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };

  const getCurrentDateInput = () => {
    const dateObj = new Date();

    // get the month in this format of 04, the same for months
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();

    const shortDate = `${year}-${month}-${day}`;

    setInputs((values) => ({ ...values, ["date"]: shortDate }));
    setInputs((values) => ({
      ...values,
      ["expected_production_date"]: shortDate,
    }));

    // Get the current time in the format "HH:mm"
    const hours = ("0" + dateObj.getHours()).slice(-2);
    const minutes = ("0" + dateObj.getMinutes()).slice(-2);

    const defaultTime = `${hours}:${minutes}`;

    setInputs((values) => ({ ...values, ["time"]: defaultTime }));
  };

  const addMoreList = (id) => {
    setList((prevList) => {
      const index = prevList.findIndex(
        (item) => Number(item.product_id) === Number(id),
      );

      if (index !== -1) {
        Swal.fire({
          title: "Error!",
          text: "This Product already in the list ! Please choose another RMPM.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return prevList;
      }
      Http.get(`/add-new-rmpm-receipe/${id}`).then((res) => {
        setList((current) => [...current, { ...res.data, request_qty: 1 }]);
      });

      return prevList;
    });
  };

  // Remove List
  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const inputInfo = [...list]; // Load All Existing experience State Data
        inputInfo.splice(index, 1); // Remove Experience by Index/Click Event Wise
        setList(inputInfo); // Replace Existing experience into State
      }
    });
  };

  const formSubmit = () => {
    checkRequiredFields();

    // Prepare items data only if list has items
    const preparedItems =
      list.length > 0
        ? list.map((item) => ({
            product_id: item.product_id || item.id,
            issue_qty: parseFloat(item.issue_qty) || 0,
            description: item.description || "",
          }))
        : [];

    // Add items to inputs
    const submitData = {
      ...inputs,
      items: preparedItems,
    };

    Http.post("/production", submitData)
      .then((res) => {
        navigate("/production", {
          state: {
            message: res.data.message,
            type: res.data.type || "success",
          },
        });
      })
      .catch(function (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          setError(e.response.data.errors);
        }
      });
  };
  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };
  const cols = [
    { field: (item) => item.code + " - " + item.name+" - "+item.unit_name, header: "Item" },
    // { field: (item) => item.unit_qty + " " + item.unit_name, header: "Unit" },
    { field: "stockQty", header: "Stock" },
  ];

  const actionTemplate = (item, deleteData) => {
    console.log(item);

    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item.id)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Generate Production</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-7">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Generate Production
            </h6>
            <hr></hr>
            {/* <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div> */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />

                    {displayError("date")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Time <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="time"
                      value={inputs.time || ""}
                      onChange={handleChange}
                      placeholder="Input Time"
                      data-required
                    />
                    {displayError("time")}
                  </div>
                  <div className="col-lg">
                    <label>
                      Req. No. <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="receipt_no"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                      placeholder="Input Receipt No"
                      data-required
                    />
                    {displayError("receipt_no")}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg">
                    <label>
                      Batch Size <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="batch_size"
                      className="form-control"
                      name="batch_size"
                      value={inputs.batch_size || ""}
                      onChange={handleChange}
                      placeholder="Input Batch Size"
                      data-required
                    />
                    {displayError("batch_size")}
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Finished Good <i className="fa fa-star required"></i>
                    </label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      defaultValue={product[0]}
                      name="product_id"
                      options={product}
                      onChange={handleSelectChange}
                      data-required
                    />
                    {displayError("product_id")}
                  </div>
                </div>
                {!(inputs.fg_out > 0) && (
                  <div className="row mt-3">
                    <div className="card-solid">
                      <div className="card-header with-border text-center">
                        <h5 className="card-title mb-0">Items List</h5>
                      </div>
                      <div className="card-body mt-3 p-0 pt-3">
                        <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                          <thead>
                            <tr>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Code
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Product
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Qty
                              </th>
                              <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from(list).map((x, i) => (
                              <ReceipeDetail
                                key={i}
                                listInfo={x}
                                listSl={i}
                                rmpm={rmpm}
                                remove={() => removeList(i)}
                                listInputChange={(e) =>
                                  handleCustomInputChange(e, i)
                                }
                              />
                            ))}
                            {receipeNotFound != "" ? (
                              <tr>
                                <td colSpan={5}>
                                  <p
                                    style={{ color: "red" }}
                                    className="text-center mt-3"
                                  >
                                    {receipeNotFound}
                                  </p>
                                </td>
                              </tr>
                            ) : (
                              ""
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="card pd-20 pd-sm-40 col-4"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Raw &amp; Packaging Materials
            </h6>
            <hr></hr>

            <ReactDataTable
              cols={cols}
              receiveData={rmpm}
              isLoading={loading}
              actionTemplate={actionTemplate}
              // deleteData={deleteData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
